import { useForm } from "react-hook-form";
import { Button, Loading, Modal, TextInput } from "@/components/atoms";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { useRecommendProviderMutation } from "@/redux/apis/recommend/recommendApi";
import { addToast } from "@/utils";

type FormData = {
  email: string;
};

interface InviteNetworkEmailModalProps {
  open: boolean;
  onClose: () => void;
}

export const InviteNetworkEmailModal = ({ open, onClose }: InviteNetworkEmailModalProps) => {
  const [recommendProvider, { isLoading }] = useRecommendProviderMutation();
  const { register, handleSubmit } = useForm<FormData>();

  const onSubmit = (data: FormData) => {
    if (!data) return;

    recommendProvider(data.email)
      .unwrap()
      .then(() => {
        addToast("success", "Successfully Sent an Invitation Email");
        onClose();
      })
      .catch((e) => getErrorMessages(e).forEach((m) => addToast("danger", m)));
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      variant="web-small"
      title="Invite a Company to RideMinder"
      description="Send an email invite to a transport company who is not yet a part of RideMinder Network. Once they are registered, you will then be able to invite them into your private network"
      headerClassName="items-center text-center"
      renderButtons={() => (
        <Button variant="primary" size="lg" onClick={handleSubmit(onSubmit)} className="w-full">
          Send an Invitation Email
        </Button>
      )}
    >
      {isLoading && <Loading />}
      <TextInput placeholder="Enter Email" className="w-full" maxLength={254} type="email" required {...register("email")} />
    </Modal>
  );
};
